export const BASELINE_LAYER_ID = "BaselineLayer";
export const SLOT_LAYER_ID = "SlotLayer";
